import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { Link, withRouter } from 'react-router-dom';
import {
  List,
  Avatar,
  Hidden,
  Drawer,
  Divider,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core';
import {
  Receipt,
  SupervisorAccount,
  Person,
  ExitToApp,
  Settings,
} from '@material-ui/icons';

import CollapsableListItem from './CollapsableListItem';
import ErrorDialog from './ErrorDialog';
import Spinner from './Spinner';
import { Can } from '../utils/ability-context';

import isAuthenticated from '../utils/session';

const styles = theme => ({
  drawer: {
    width: 300,
    border: 'none',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      width: theme.spacing.unit * 9,
      overflowX: 'hidden',
    },
    height: '100vh',
  },
  border: {
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  },
  toolbar: theme.mixins.toolbar,
  avatarItem: {
    paddingLeft: theme.spacing.unit * 2,
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
});

class SideMenu extends PureComponent {
  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    if (!isAuthenticated()) {
      history.push('/login');
    }
  }

  renderDrawer() {
    const { classes, location: { pathname }, user, logOut } = this.props;

    return (
      <div>
        <div className={classes.toolbar} />
        <Divider />
        <List>
          <CollapsableListItem
            listItemClass={classes.avatarItem}
            listItemIcon={
              (<Avatar className={classes.avatar}>
                <Person />
              </Avatar>)
            }
            listItemText={
              (<ListItemText primary={`${user.first_name} ${user.last_name}`} secondary={user.username} />)
            }
            nestedList={
              (<List component="div" disablePadding>
                <ListItem button onClick={logOut}>
                  <ListItemIcon>
                    <ExitToApp />
                  </ListItemIcon>
                  <ListItemText inset primary="Cerrar Sesión" />
                </ListItem>
                <Can I="update" a="Profile">
                  <ListItem button component={Link} to="/profile">
                    <ListItemIcon>
                      <Settings />
                    </ListItemIcon>
                    <ListItemText inset primary="Mis Datos" />
                  </ListItem>
                </Can>
              </List>)
            }
          />
        </List>
        <Divider />
        <List>
          <Can I="read" a="Paycheck">
            <ListItem button component={Link} to="/paychecks?page=1" selected={pathname === '/paychecks'}>
              <ListItemIcon>
                <Receipt />
              </ListItemIcon>
              <ListItemText primary="Recibos" />
            </ListItem>
          </Can>
          <Can I="read" a="Employee">
            <ListItem button component={Link} to="/users?page=1" selected={pathname === '/users'}>
              <ListItemIcon>
                <Person />
              </ListItemIcon>
              <ListItemText primary="Empleados" />
            </ListItem>
          </Can>
          <Can I="read" a="Admin">
            <ListItem button component={Link} to="/admins?page=1" selected={pathname === '/admins'}>
              <ListItemIcon>
                <SupervisorAccount />
              </ListItemIcon>
              <ListItemText primary="Administradores" />
            </ListItem>
          </Can>
        </List>
      </div>
    );
  }

  render() {
    const {
      classes,
      theme,
      isOpen,
      onClose,
      error,
      isFetching,
      clearError,
    } = this.props;

    return (
      <div className={classes.border}>
        <Hidden smUp>
          <Drawer
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={isOpen}
            onClose={onClose}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {this.renderDrawer()}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            variant="permanent"
            open
            classes={{
              paper: classes.drawer,
            }}
          >
            {this.renderDrawer()}
          </Drawer>
        </Hidden>
        { (error.error || error.message) &&
          <ErrorDialog error={error.error || error.message} action={clearError} />
        }
        { isFetching && <Spinner /> }
      </div>
    );
  }
}

export default compose(
  withRouter,
  withStyles(styles, { withTheme: true }),
)(SideMenu);

SideMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  logOut: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  clearError: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/SideMenu.js